import React, { useEffect, useState } from "react";
import query from "jquery";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import { useGlobal } from "../context/GlobalContext";
import api from '../api/axios';
import { formatProductData, generateSlug } from '../helper/formatProductData';
// Dynamic Banner Carousel removed to inside component

const HeaderOne = () => {
  const { cartItems, wishlistItems, categories, globalSearchQuery, setGlobalSearchQuery } = useGlobal();
  const shopCategories = categories.filter(c => !c.showInHeader);
  const headerCategories = categories.filter(c => c.showInHeader);
  const [productsData, setProductsData] = useState([]);
  const [localSearch, setLocalSearch] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const searchParam = params.get('search');
    if (searchParam) {
      setLocalSearch(decodeURIComponent(searchParam));
    } else if (location.pathname === '/' || (location.pathname === '/shop' && !location.search.includes('search='))) {
      setLocalSearch("");
    }
  }, [location.pathname, location.search]);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (!localSearch || !localSearch.trim()) {
      return;
    }
    const searchTerm = localSearch.trim();
    setActiveSearch(false);
    navigate(`/shop?search=${encodeURIComponent(searchTerm)}`);
  };

  const handleHomeClick = () => {
    setLocalSearch("");
    setGlobalSearchQuery("");
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await api.get('/api/products');
        setProductsData(response.data.map(formatProductData));
      } catch (err) {
        console.error("Failed to fetch products for header", err);
      }
    };
    fetchProducts();
  }, []);
  const [scroll, setScroll] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset < 150) {
        setScroll(false);
      } else if (window.pageYOffset > 150) {
        setScroll(true);
      }
    };
    window.addEventListener('scroll', handleScroll);

    const selectElement = query(".js-example-basic-single");
    if (selectElement.length > 0 && typeof selectElement.select2 === 'function') {
      selectElement.select2();
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (selectElement.length > 0 && selectElement.data && selectElement.data("select2") && typeof selectElement.select2 === 'function') {
        selectElement.select2("destroy");
      }
    };
  }, []);

  // Banner carousel
  const [bannerSlides, setBannerSlides] = useState([
    "Wait, Loading Marquee Updates...",
    "🌿 100% Organic & Natural Products — Delivered Fresh to Your Door"
  ]);

  useEffect(() => {
    const fetchMarquee = async () => {
      try {
        const response = await api.get('/api/marquee');
        if (response.data && response.data.length > 0) {
          setBannerSlides(response.data);
        } else {
          // fallback if empty db
          setBannerSlides(["🌿 100% Organic & Natural Products — Delivered Fresh to Your Door"]);
        }
      } catch (err) {
        console.error("Failed to fetch marquee messages", err);
      }
    };
    fetchMarquee();
  }, []);

  const [currentSlide, setCurrentSlide] = useState(0);
  const [slideVisible, setSlideVisible] = useState(true);
  useEffect(() => {
    const interval = setInterval(() => {
      setSlideVisible(false);
      setTimeout(() => {
        setCurrentSlide((prev) => (prev + 1) % bannerSlides.length);
        setSlideVisible(true);
      }, 400);
    }, 4000);
    return () => clearInterval(interval);
  }, [bannerSlides]);

  // Mobile menu support
  const [menuActive, setMenuActive] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const handleMenuClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const handleMenuToggle = () => {
    setMenuActive(!menuActive);
  };

  // Search control support
  const [activeSearch, setActiveSearch] = useState(false);
  const handleSearchToggle = () => {
    setActiveSearch(!activeSearch);
  };

  const [activeShopSub, setActiveShopSub] = useState(null);
  const handleShopSubClick = (e, index) => {
    e.stopPropagation();
    setActiveShopSub(activeShopSub === index ? null : index);
  };

  // Account popup logic
  const [accountPopupOpen, setAccountPopupOpen] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const isLoggedIn = !!localStorage.getItem('token');
  const loggedInUserName = localStorage.getItem('userName') || 'My Account';

  const handleConfirmLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userName');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('userPhone');
    setShowLogoutModal(false);
    navigate('/');
    window.location.reload();
  };

  const handleAccountClick = (e) => {
    // ALWAYS stop navigation and toggle popup, whether logged in or not
    e.preventDefault();
    e.stopPropagation();
    setAccountPopupOpen(!accountPopupOpen);
  };

  useEffect(() => {
    const closePopup = () => setAccountPopupOpen(false);
    if (accountPopupOpen) {
      document.addEventListener('click', closePopup);
    }
    return () => document.removeEventListener('click', closePopup);
  }, [accountPopupOpen]);

  const AccountPopup = ({ alignLeft = false }) => {
    const userEmail = localStorage.getItem('userEmail') || '';
    const initials = loggedInUserName.substring(0, 2).toUpperCase();

    return (
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          position: 'absolute',
          top: 'calc(100% + 8px)',
          zIndex: 9999,
          background: '#fff',
          borderRadius: '16px',
          boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
          padding: '24px',
          width: 'max-content',
          minWidth: '280px',
          display: accountPopupOpen ? 'block' : 'none',
          color: '#333',
          border: '1px solid #efefef',
          cursor: 'default',
          right: alignLeft ? 'auto' : 0,
          left: alignLeft ? '-8px' : 'auto',
        }}
      >
        {isLoggedIn ? (
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px', paddingBottom: '16px', borderBottom: '1px solid #efefef', marginBottom: '16px' }}>
              <div style={{ width: 44, height: 44, borderRadius: '50%', background: '#E0503A', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, fontWeight: 700 }}>
                {initials}
              </div>
              <div style={{ textAlign: 'left' }}>
                <h6 style={{ margin: 0, fontSize: '15px', fontWeight: 600, color: '#1B1B1B' }}>{loggedInUserName}</h6>
                <div style={{ fontSize: '12px', color: '#8A8A8A', marginTop: 2 }}>{userEmail}</div>
              </div>
            </div>

            <Link to="/account" onClick={() => setAccountPopupOpen(false)} style={{ display: 'flex', alignItems: 'center', gap: '12px', color: '#4A4A4A', textDecoration: 'none', padding: '10px 0', fontSize: '15px' }}>
              <i className="ph ph-user" style={{ fontSize: '20px' }}></i> My Account
            </Link>

            <Link to="/account?tab=orders" onClick={() => setAccountPopupOpen(false)} style={{ display: 'flex', alignItems: 'center', gap: '12px', color: '#4A4A4A', textDecoration: 'none', padding: '10px 0', fontSize: '15px' }}>
              <i className="ph ph-receipt" style={{ fontSize: '20px' }}></i> My Orders
            </Link>

            <div style={{ height: '1px', background: '#efefef', margin: '12px 0' }} />

            <button onClick={() => { setAccountPopupOpen(false); setShowLogoutModal(true); }} style={{ width: '100%', textAlign: 'left', background: 'none', border: 'none', padding: '10px 0', color: '#E0503A', display: 'flex', alignItems: 'center', gap: '12px', fontSize: '15px', cursor: 'pointer' }}>
              <i className="ph ph-sign-out" style={{ fontSize: '20px' }}></i> Logout
            </button>
          </div>
        ) : (
          <div>
            <h5 style={{ fontWeight: 700, margin: 0, fontSize: '18px', color: '#1B1B1B' }}>Welcome!</h5>
            <p style={{ margin: '6px 0 20px', color: '#8A8A8A', fontSize: '13px' }}>Sign in to view orders &amp; wishlist</p>
            <div style={{ display: 'flex', gap: '12px' }}>
              <Link
                to="/login"
                onClick={() => setAccountPopupOpen(false)}
                style={{
                  flex: 1, textAlign: 'center', background: 'var(--main-600, #2FA84F)', color: '#fff',
                  padding: '10px 16px', borderRadius: '999px', fontSize: '15px', fontWeight: 600,
                  textDecoration: 'none', lineHeight: '1.4'
                }}>
                Login
              </Link>
              <Link
                to="/register"
                onClick={() => setAccountPopupOpen(false)}
                style={{
                  flex: 1, textAlign: 'center', background: '#fff', color: 'var(--main-600, #2FA84F)',
                  border: '1.5px solid var(--main-600, #2FA84F)', padding: '10px 16px', borderRadius: '999px',
                  fontSize: '15px', fontWeight: 600, textDecoration: 'none', lineHeight: '1.4'
                }}>
                Register
              </Link>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <style>{`
        /* Logout Modal Styles */
        .logout-modal-overlay {
            position: fixed;
            top: 0; left: 0; width: 100vw; height: 100vh;
            background: rgba(0,0,0,0.4);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 99999;
            backdrop-filter: blur(3px);
        }
        .logout-modal-box {
            background: #fff;
            width: 400px;
            max-width: 90%;
            border-radius: 16px;
            padding: 32px 24px;
            text-align: center;
            box-shadow: 0 10px 30px rgba(0,0,0,0.1);
            animation: scaleUp 0.3s ease;
        }
        .logout-icon-wrap {
            width: 64px; height: 64px;
            background: #FDF3F2;
            color: #E0503A;
            border-radius: 50%;
            display: inline-flex;
            align-items: center; justify-content: center;
            font-size: 32px;
            margin-bottom: 20px;
        }
        @keyframes scaleUp {
            from { transform: scale(0.9); opacity: 0; }
            to { transform: scale(1); opacity: 1; }
        }
      `}</style>
      {showLogoutModal && (
        <div className="logout-modal-overlay" onClick={() => setShowLogoutModal(false)}>
          <div className="logout-modal-box" onClick={(e) => e.stopPropagation()}>
            <div className="logout-icon-wrap">
              <i className="ph ph-sign-out" />
            </div>
            <h4 className="mb-12">Sign Out</h4>
            <p className="text-gray-600 mb-24">Are you sure you want to log out of your account?</p>
            <div className="flex-align gap-16 justify-content-center">
              <button
                className="btn py-12 px-24 rounded-8 border border-gray-200 text-gray-700 bg-white"
                onClick={() => setShowLogoutModal(false)}
              >
                Cancel
              </button>
              <button
                className="btn py-12 px-24 rounded-8"
                style={{ background: '#E0503A', color: '#fff' }}
                onClick={handleConfirmLogout}
              >
                Yes, Logout
              </button>
            </div>
          </div>
        </div>
      )}
      {(activeSearch || menuActive) && (
        <div
          className={`overlay show-overlay`}
          onClick={() => { setActiveSearch(false); setMenuActive(false); setActiveShopSub(null); setActiveIndex(null); }}
        />
      )}
      {menuActive && (
        <div
          className={`side-overlay show`}
          onClick={() => setMenuActive(false)}
        />
      )}
      {/* ==================== Search Box Start Here ==================== */}
      <form onSubmit={handleSearchSubmit} className={`search-box ${activeSearch ? "active" : ""}`}>
        <button
          onClick={handleSearchToggle}
          type='button'
          className='search-box__close position-absolute inset-block-start-0 inset-inline-end-0 m-16 w-48 h-48 border border-gray-100 rounded-circle flex-center text-white hover-text-gray-800 hover-bg-white text-2xl transition-1'
        >
          <i className='ph ph-x' />
        </button>
        <div className='container'>
          <div className='position-relative'>
            <input
              type='text'
              value={localSearch}
              onChange={(e) => setLocalSearch(e.target.value)}
              className='form-control py-16 px-24 text-xl rounded-pill pe-64'
              placeholder='Search for a product or brand'
            />
            <button
              type='submit'
              className='w-48 h-48 bg-main-600 rounded-circle flex-center text-xl text-white position-absolute top-50 translate-middle-y inset-inline-end-0 me-8'
            >
              <i className='ph ph-magnifying-glass' />
            </button>
          </div>
        </div>
      </form>
      {/* ==================== Search Box End Here ==================== */}
      {/* ==================== Mobile Menu Start Here ==================== */}
      <div
        className={`mobile-menu scroll-sm d-lg-none d-block ${menuActive && "active"
          }`}
      >
        <button
          onClick={() => {
            handleMenuToggle();
            setActiveIndex(null);
          }}
          type='button'
          className='close-button'
        >
          <i className='ph ph-x' />{" "}
        </button>
        <div className='mobile-menu__inner'>
          <Link to='/' className='mobile-menu__logo' onClick={handleHomeClick}>
            <img src='/assets/images/logo/logo.png' alt='Logo' />
          </Link>
          <div className='mobile-menu__menu'>
            {/* Nav Menu Start */}
            <ul className='nav-menu flex-align nav-menu--mobile'>
              {/* Home Menu */}
              <li className='nav-menu__item'>
                <Link
                  to='/'
                  className='nav-menu__link'
                  onClick={() => {
                    setMenuActive(false);
                    setActiveIndex(null);
                    handleHomeClick();
                  }}
                >
                  Home
                </Link>
              </li>

              {/* About Us Menu */}
              <li className='nav-menu__item'>
                <Link
                  to='/about'
                  className='nav-menu__link'
                  onClick={() => {
                    setMenuActive(false);
                    setActiveIndex(null);
                  }}
                >
                  About Us
                </Link>
              </li>

              {/* Shop Menu */}
              <li
                className={`nav-menu__item has-submenu ${activeIndex === 1 ? "d-block" : ""}`}
              >
                <div
                  className="d-lg-none"
                  style={{ position: 'absolute', right: 0, top: 0, width: '50px', height: '48px', zIndex: 10, cursor: 'pointer' }}
                  onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleMenuClick(1); }}
                />
                <Link
                  to='/shop'
                  className='nav-menu__link'
                  onClick={() => {
                    setMenuActive(false);
                    setActiveIndex(null);
                    setGlobalSearchQuery("");
                    setLocalSearch("");
                  }}
                >
                  Shop
                </Link>
                <ul
                  className={`common-dropdown nav-submenu scroll-sm submenus-submenu-wrapper ${activeIndex === 1 ? "open" : ""
                    }`}
                  style={{
                    overflow: 'unset',
                    position: activeIndex === 1 ? 'static' : 'absolute',
                    visibility: activeIndex === 1 ? 'visible' : 'hidden',
                    opacity: activeIndex === 1 ? 1 : 0,
                    display: activeIndex === 1 ? 'block' : 'none',
                    boxShadow: 'none',
                    paddingLeft: '16px',
                    top: 'auto',
                    left: 'auto',
                    transform: 'none'
                  }}
                >
                  {shopCategories.map((cat, idx) => {
                    const hasSubs = cat.subcategories && cat.subcategories.length > 0;
                    const catProducts = productsData.filter(p => String(p.categoryId) === String(cat.id));

                    const subItems = hasSubs
                      ? cat.subcategories.map(sub => ({ label: sub.label, link: `/shop/${generateSlug(sub.label)}` }))
                      : catProducts.map(p => ({ label: p.name, link: `/product-details/${p.slug || p.id}` }));

                    return (
                      <li
                        key={cat.id}
                        onClick={(e) => handleShopSubClick(e, idx)}
                        className={`has-submenus-submenu ${activeShopSub === idx ? "active" : ""}`}
                      >
                        <Link
                          to={`/shop/${generateSlug(cat.label)}`}
                          className='common-dropdown__link nav-submenu__link hover-bg-neutral-100 flex-between gap-8'
                          onClick={() => { setMenuActive(false); setActiveIndex(null); setActiveShopSub(null); setGlobalSearchQuery(""); setLocalSearch(""); }}
                        >
                          <span>{cat.label}</span>
                        </Link>
                        {subItems.length > 0 && (
                          <div
                            className={`submenus-submenu py-16 ${activeShopSub === idx ? "open" : ""}`}
                            style={{
                              position: activeShopSub === idx ? 'static' : 'absolute',
                              visibility: activeShopSub === idx ? 'visible' : 'hidden',
                              opacity: activeShopSub === idx ? 1 : 0,
                              display: activeShopSub === idx ? 'block' : 'none',
                              boxShadow: 'none',
                              paddingLeft: '16px'
                            }}
                          >
                            <h6 className='text-lg px-16 submenus-submenu__title'>
                              {cat.label}
                            </h6>
                            <ul className='submenus-submenu__list max-h-300 overflow-y-auto scroll-sm'>
                              {subItems.map((item, pIdx) => (
                                <li key={pIdx}>
                                  <Link to={item.link} onClick={() => { setMenuActive(false); setActiveIndex(null); setActiveShopSub(null); }}>{item.label}</Link>
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </li>
                    )
                  })}
                </ul>
              </li>

              {/* Dynamic Header Categories (promoted via admin toggle) */}
              {headerCategories.map((cat, hIdx) => {
                const hasSubs = cat.subcategories && cat.subcategories.length > 0;
                const catProducts = productsData.filter(p => String(p.categoryId) === String(cat.id));
                const subItems = hasSubs
                  ? cat.subcategories.map(sub => ({ label: sub.label, link: `/shop/${generateSlug(sub.label)}` }))
                  : catProducts.map(p => ({ label: p.name, link: `/shop/${p.slug}` }));
                const menuKey = `hdr-cat-${cat.id || hIdx}`;
                const isOpen = activeIndex === menuKey;

                return (
                  <li
                    key={cat.id}
                    className={`nav-menu__item ${subItems.length > 0 ? "has-submenu" : ""} ${isOpen ? "d-block" : ""}`}
                  >
                    {subItems.length > 0 && (
                      <div
                        className="d-lg-none"
                        style={{ position: 'absolute', right: 0, top: 0, width: '50px', height: '48px', zIndex: 10, cursor: 'pointer' }}
                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleMenuClick(menuKey); }}
                      />
                    )}
                    <Link
                      to={`/shop/${generateSlug(cat.label)}`}
                      className='nav-menu__link'
                      onClick={() => { setMenuActive(false); setActiveIndex(null); }}
                    >
                      {cat.label}
                    </Link>
                    {subItems.length > 0 && (
                      <ul
                        className={`common-dropdown nav-submenu scroll-sm ${isOpen ? "open" : ""}`}
                        style={{
                          position: isOpen ? 'static' : 'absolute',
                          visibility: isOpen ? 'visible' : 'hidden',
                          opacity: isOpen ? 1 : 0,
                          display: isOpen ? 'block' : 'none',
                          boxShadow: 'none',
                          paddingLeft: '16px',
                          top: 'auto',
                          left: 'auto',
                          transform: 'none'
                        }}
                      >
                        {subItems.map((item, pIdx) => (
                          <li key={pIdx}>
                            <Link
                              to={item.link}
                              className='common-dropdown__link nav-submenu__link hover-bg-neutral-100'
                              onClick={() => {
                                setMenuActive(false);
                                setActiveIndex(null);
                              }}
                            >
                              {item.label}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                );
              })}

              {/* Blog Menu */}
              <li className='nav-menu__item'>
                <Link
                  to='/blog'
                  className='nav-menu__link'
                  onClick={() => {
                    setMenuActive(false);
                    setActiveIndex(null);
                  }}
                >
                  Blog
                </Link>
              </li>

              {/* Contact Us Menu */}
              <li className='nav-menu__item'>
                <Link
                  to='/contact'
                  className='nav-menu__link'
                  onClick={() => {
                    setMenuActive(false);
                    setActiveIndex(null);
                  }}
                >
                  Contact Us
                </Link>
              </li>
            </ul>
            {/* Nav Menu End */}
          </div>
        </div>
      </div>
      {/* ==================== Mobile Menu End Here ==================== */}
      <div className='header-top bg-main-600' style={{ padding: '0' }}>
        <style>{`
          @keyframes sliverMarquee {
            0% { transform: translateX(0%); }
            100% { transform: translateX(-50%); }
          }
          .sliver-marquee-container {
            overflow: hidden;
            white-space: nowrap;
            width: 100%;
            display: flex;
            align-items: center;
            position: relative;
            mask-image: linear-gradient(to right, transparent, black 4%, black 96%, transparent);
            -webkit-mask-image: linear-gradient(to right, transparent, black 4%, black 96%, transparent);
          }
          .sliver-marquee-content {
            display: inline-flex;
            align-items: center;
            white-space: nowrap;
            animation: sliverMarquee 42s linear infinite;
            will-change: transform;
          }
          .sliver-marquee-content:hover {
            animation-play-state: paused;
          }
          .sliver-marquee-item {
            display: inline-flex;
            align-items: center;
            padding: 0 10px;
            color: #ffffff;
            font-size: 0.78rem;
            font-weight: 500;
            letter-spacing: 0.01em;
          }
        `}</style>
        <div className='container container-lg'  >
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            minHeight: '36px',
            gap: '8px',
          }}>
            {/* Left: About Us (Desktop) & My Account (Mobile) */}
            <ul className='flex-align' style={{ margin: 0, padding: 0, listStyle: 'none', flexShrink: 0 }}>
              <li className="d-none d-lg-block">
                <Link
                  to='/about'
                  className='text-white text-sm hover-text-decoration-underline'
                  style={{ whiteSpace: 'nowrap' }}
                >
                  About Us
                </Link>
              </li>
              <li className="d-block d-lg-none" style={{ position: 'relative' }}>
                <Link
                  to='/account'
                  className='text-white text-sm py-8 flex-align gap-6'
                  style={{ whiteSpace: 'nowrap' }}
                  onClick={handleAccountClick}
                >
                  <span className='icon text-md d-flex'>
                    <i className='ph ph-user-circle' />
                  </span>
                  <span className='hover-text-decoration-underline text-xs'>
                    {isLoggedIn ? loggedInUserName : 'My Account'}
                  </span>
                </Link>
                <AccountPopup alignLeft={true} />
              </li>
            </ul>

            {/* Center: Animated Promo Carousel (Desktop) & Infinite Scrolling Marquee (Mobile) */}
            <div style={{
              flex: 1,
              overflow: 'hidden',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '0 8px',
              minWidth: 0,
            }}>
              {/* Desktop: Rotating Slide Transition */}
              <div
                className="d-none d-lg-block w-100"
                style={{
                  transition: 'opacity 0.4s ease, transform 0.4s ease',
                  opacity: slideVisible ? 1 : 0,
                  transform: slideVisible ? 'translateY(0)' : 'translateY(-8px)',
                  textAlign: 'center',
                  color: '#fff',
                  fontSize: '0.8125rem',
                  fontWeight: 500,
                  letterSpacing: '0.01em',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: '100%',
                }}
              >
                {bannerSlides[currentSlide]}
              </div>

              {/* Mobile & Tablet: Continuous Smooth Scrolling Marquee */}
              <div className="d-block d-lg-none sliver-marquee-container">
                <div className="sliver-marquee-content">
                  {/* Loop 1 */}
                  {bannerSlides.map((msg, idx) => (
                    <span key={`s1_${idx}`} className="sliver-marquee-item">
                      {msg}
                      <span className="mx-8 opacity-50">•</span>
                    </span>
                  ))}
                  {/* Loop 2 for smooth seamless infinite scroll */}
                  {bannerSlides.map((msg, idx) => (
                    <span key={`s2_${idx}`} className="sliver-marquee-item">
                      {msg}
                      <span className="mx-8 opacity-50">•</span>
                    </span>
                  ))}
                  {/* Loop 3 if list has only 1 message */}
                  {bannerSlides.length <= 2 && bannerSlides.map((msg, idx) => (
                    <span key={`s3_${idx}`} className="sliver-marquee-item">
                      {msg}
                      <span className="mx-8 opacity-50">•</span>
                    </span>
                  ))}
                </div>
              </div>
            </div>

            {/* Right: My Account (Desktop Only) */}
            <ul className='flex-align d-none d-lg-flex' style={{ margin: 0, padding: 0, listStyle: 'none', flexShrink: 0 }}>
              <li style={{ position: 'relative' }}>
                <Link
                  to='/account'
                  className='text-white text-sm py-8 flex-align gap-6'
                  style={{ whiteSpace: 'nowrap' }}
                  onClick={handleAccountClick}
                >
                  <span className='icon text-md d-flex'>
                    <i className='ph ph-user-circle' />
                  </span>
                  <span className='hover-text-decoration-underline'>
                    {isLoggedIn ? loggedInUserName : 'My Account'}
                  </span>
                </Link>
                <AccountPopup />
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* ======================= Middle Top End ========================= */}
      {/* ======================= Middle Header Start ========================= */}
      <header className='header-middle bg-color-one border-bottom border-gray-100' style={{ padding: '6px 0' }}>
        <style>{`
          .header-middle-nav { display: flex; align-items: center; gap: 24px; height: 80px; }
          .header-middle-search { flex: 1; display: flex; align-items: center; justify-content: center; min-width: 0; }
          .logo-img { max-height: 68px; width: auto; object-fit: contain; transform: scale(1.42); transform-origin: left center; }
          
          /* iPad Pro and smaller desktops (992px to 1199px) */
          @media (max-width: 1199px) {
            .header-middle-nav { gap: 16px; }
            .header-middle-search { justify-content: center; margin: 0 12px; }
            .search-bar-box { width: 100% !important; max-width: 520px !important; }
            .logo-img { max-height: 64px; transform: scale(1.25); }
          }
          /* Tablets - iPad Air, iPad Mini (576px to 991px) */
          @media (min-width: 576px) and (max-width: 991px) {
            .header-middle-nav { gap: 16px; justify-content: space-between; }
            .header-middle-logo-wrap { flex: 0 0 auto; }
            .header-middle-search { flex: 1; justify-content: flex-end; margin-left: 16px; min-width: 0; }
            .search-bar-box { width: 100% !important; max-width: 480px !important; height: 44px !important; }
            .logo-img { max-height: 58px; transform: scale(1.3); }
          }
          /* Mobile Phones (< 576px) */
          @media (max-width: 575px) {
            .header-middle-nav { gap: 8px; justify-content: space-between; height: 68px; }
            .logo-img { max-height: 54px; transform: scale(1.22); transform-origin: left center; }
            .header-middle-logo-wrap { flex: 0 0 auto; display: flex; justify-content: flex-start; align-items: center; }
            .header-middle-search { flex: 1; justify-content: flex-end; margin-left: 8px; min-width: 0; }
            .search-bar-box { width: 100% !important; max-width: 260px !important; height: 42px !important; }
            .search-bar-box input { padding: 0 10px 0 14px !important; font-size: 0.82rem !important; }
            .search-bar-button { width: 36px !important; height: 36px !important; font-size: 0.95rem !important; margin: 2px !important; }
          }
          /* Extra small phones (< 380px) */
          @media (max-width: 380px) {
            .header-middle-nav { gap: 6px; }
            .logo-img { max-height: 48px; transform: scale(1.12); }
            .search-bar-box { max-width: 220px !important; height: 40px !important; }
            .search-bar-box input { padding: 0 8px 0 10px !important; font-size: 0.78rem !important; }
            .search-bar-button { width: 34px !important; height: 34px !important; font-size: 0.88rem !important; }
          }
        `}</style>
        <div className='container container-lg'  >
          <nav className="header-middle-nav">

            {/* Left Spacer for Mobile Centering removed to allow logo to align left */}

            {/* Logo */}
            <Link
              to='/'
              className='header-middle-logo-wrap link'
              onClick={handleHomeClick}
              style={{
                flexShrink: 0,
                display: 'flex',
                alignItems: 'center',
                height: '68px',
                overflow: 'visible',
              }}
            >
              <img
                src='/assets/images/logo/logo.png'
                alt='Healthy Home'
                className="logo-img"
              />
            </Link>

            <div className="header-middle-search">
              <form className="search-bar-box" onSubmit={handleSearchSubmit} style={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                maxWidth: '600px',
                border: '1.5px solid #d1d5db',
                borderRadius: '999px',
                overflow: 'hidden',
                background: '#fff',
                height: '46px',
                boxShadow: '0 1px 4px rgba(0,0,0,0.07)',
              }}>
                <input
                  type='text'
                  value={localSearch}
                  onChange={(e) => setLocalSearch(e.target.value)}
                  placeholder='Search products...'
                  style={{
                    flex: 1,
                    border: 'none',
                    outline: 'none',
                    padding: '0 12px 0 16px',
                    fontSize: '0.85rem',
                    color: '#374151',
                    background: 'transparent',
                    minWidth: 0,
                    textOverflow: 'ellipsis',
                  }}
                />
                <button
                  type='submit'
                  className="search-bar-button"
                  style={{
                    width: '44px',
                    height: '44px',
                    borderRadius: '50%',
                    background: '#4CAF50',
                    border: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fff',
                    fontSize: '1.1rem',
                    cursor: 'pointer',
                    flexShrink: 0,
                    margin: '1px 1px 1px 0',
                    transition: 'background 0.2s',
                  }}
                >
                  <i className='ph ph-magnifying-glass' />
                </button>
              </form>
            </div>

            {/* Right: Wishlist + Cart (Desktop Only) */}
            <div className="d-none d-lg-flex" style={{ flexShrink: 0, alignItems: 'center', gap: '24px' }}>
              <Link to='/wishlist' style={{ display: 'flex', alignItems: 'center', gap: '6px', textDecoration: 'none', color: '#374151' }}>
                <span style={{ position: 'relative', display: 'flex', fontSize: '1.45rem' }}>
                  <i className='ph ph-heart' />
                  <span style={{
                    position: 'absolute', top: '-6px', right: '-6px',
                    width: '17px', height: '17px', borderRadius: '50%',
                    background: '#4CAF50', color: '#fff',
                    fontSize: '0.6rem', display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontWeight: 700,
                  }}>{wishlistItems.length}</span>
                </span>
                <span style={{ fontSize: '0.875rem', color: '#6b7280' }}>Wishlist</span>
              </Link>

              <Link to='/cart' style={{ display: 'flex', alignItems: 'center', gap: '6px', textDecoration: 'none', color: '#374151' }}>
                <span style={{ position: 'relative', display: 'flex', fontSize: '1.45rem' }}>
                  <i className='ph ph-shopping-cart-simple' />
                  <span style={{
                    position: 'absolute', top: '-6px', right: '-6px',
                    width: '17px', height: '17px', borderRadius: '50%',
                    background: '#4CAF50', color: '#fff',
                    fontSize: '0.6rem', display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontWeight: 700,
                  }}>{cartItems.length}</span>
                </span>
                <span style={{ fontSize: '0.875rem', color: '#6b7280' }}>Cart</span>
              </Link>
            </div>

          </nav>
        </div >
      </header >
      {/* ======================= Middle Header End ========================= */}
      {/* ==================== Header Start Here ==================== */}
      <header
        className={`header bg-white border-bottom border-gray-100 ${scroll && "fixed-header"
          }`}
      >
        <div className='container container-lg'  >
          <nav className='header-inner mobile-header-inner d-flex justify-content-between justify-content-lg-center align-items-center gap-8 position-relative'>
            <style>{`
              .header {
                position: relative;
                z-index: 990;
              }
              .header.fixed-header {
                z-index: 990 !important;
              }
              .header-menu {
                display: flex;
                justify-content: center;
                width: 100%;
              }
              .header-menu .nav-menu {
                justify-content: center;
              }
              @media (max-width: 1199px) {
                .nav-menu__item { padding: 0 12px !important; }
                .header-right { gap: 12px !important; }
              }
              @media (max-width: 991px) {
                .nav-menu--mobile .nav-submenu.open,
                .nav-menu--mobile .submenus-submenu.open {
                  display: block !important;
                  position: static !important;
                  visibility: visible !important;
                  opacity: 1 !important;
                  box-shadow: none !important;
                  transform: none !important;
                  padding-left: 12px !important;
                }
                .mobile-header-inner { position: relative !important; min-height: 48px; }
              }
            `}</style>
            {/* Menu Start  */}
            <div className='header-menu d-lg-flex d-none justify-content-center flex-grow-1'>
              {/* Nav Menu Start */}
              <ul className='nav-menu flex-align justify-content-center p-0 m-0'>
                  <li className='nav-menu__item'>
                    <NavLink
                      to='/'
                      onClick={handleHomeClick}
                      className={(navData) =>
                        navData.isActive
                          ? "nav-menu__link activePage"
                          : "nav-menu__link"
                      }
                    >
                      Home
                    </NavLink>
                  </li>
                  <li className='nav-menu__item'>
                    <NavLink
                      to='/about'
                      className={(navData) =>
                        navData.isActive
                          ? "nav-menu__link activePage"
                          : "nav-menu__link"
                      }
                    >
                      About Us
                    </NavLink>
                  </li>
                  <li className='on-hover-item nav-menu__item has-submenu'>
                    <Link
                      to='/shop'
                      className='nav-menu__link'
                      onClick={() => {
                        setGlobalSearchQuery("");
                        setLocalSearch("");
                      }}
                    >
                      Shop
                    </Link>
                    <ul
                      className='on-hover-dropdown common-dropdown nav-submenu scroll-sm submenus-submenu-wrapper'
                      style={{ overflow: 'unset' }}
                    >
                      {shopCategories.map((cat, idx) => {
                        const hasSubs = cat.subcategories && cat.subcategories.length > 0;
                        const catProducts = productsData.filter(p => String(p.categoryId) === String(cat.id));

                        const subItems = hasSubs
                          ? cat.subcategories.map(sub => ({ label: sub.label, link: `/shop/${generateSlug(sub.label)}` }))
                          : catProducts.map(p => ({ label: p.name, link: `/product-details/${p.slug || p.id}` }));

                        return (
                          <li className='has-submenus-submenu' key={cat.id}>
                            <NavLink
                              to={`/shop/${generateSlug(cat.label)}`}
                              className='common-dropdown__link nav-submenu__link hover-bg-neutral-100 flex-between gap-8'
                              onClick={() => {
                                setGlobalSearchQuery("");
                                setLocalSearch("");
                              }}
                            >
                              <span>{cat.label}</span>
                              {subItems.length > 0 && (
                                <span className='icon text-xs d-flex ms-auto'>
                                  <i className='ph ph-caret-right' />
                                </span>
                              )}
                            </NavLink>
                            {subItems.length > 0 && (
                              <div className='submenus-submenu py-16'>
                                <h6 className='text-lg px-16 submenus-submenu__title'>
                                  {cat.label}
                                </h6>
                                <ul className='submenus-submenu__list max-h-300 overflow-y-auto scroll-sm'>
                                  {subItems.map((item, pIdx) => (
                                    <li key={pIdx}>
                                      <NavLink to={item.link}>{item.label}</NavLink>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )}
                          </li>
                        )
                      })}
                    </ul>
                  </li>

                  {/* Dynamic Header Categories (promoted via admin toggle) */}
                  {headerCategories.map((cat) => {
                    const hasSubs = cat.subcategories && cat.subcategories.length > 0;
                    const catProducts = productsData.filter(p => String(p.categoryId) === String(cat.id));
                    const subItems = hasSubs
                      ? cat.subcategories.map(sub => ({ label: sub.label, link: `/shop/${generateSlug(sub.label)}` }))
                      : catProducts.map(p => ({ label: p.name, link: `/shop/${p.slug}` }));

                    return (
                      <li
                        key={cat.id}
                        className={`on-hover-item nav-menu__item ${subItems.length > 0 ? "has-submenu" : ""}`}
                      >
                        <NavLink
                          to={`/shop/${generateSlug(cat.label)}`}
                          className={(navData) =>
                            navData.isActive
                              ? "nav-menu__link activePage"
                              : "nav-menu__link"
                          }
                        >
                          {cat.label}
                        </NavLink>
                        {subItems.length > 0 && (
                          <ul className='on-hover-dropdown common-dropdown nav-submenu scroll-sm'>
                            {subItems.map((item, pIdx) => (
                              <li key={pIdx}>
                                <Link
                                  to={item.link}
                                  className='common-dropdown__link nav-submenu__link hover-bg-neutral-100'
                                >
                                  {item.label}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    );
                  })}


                  <li className='nav-menu__item'>
                    <NavLink
                      to='/blog'
                      className={(navData) =>
                        navData.isActive
                          ? "nav-menu__link activePage"
                          : "nav-menu__link"
                      }
                    >
                      Blog
                    </NavLink>
                  </li>
                  <li className='nav-menu__item'>
                    <NavLink
                      to='/contact'
                      className={(navData) =>
                        navData.isActive
                          ? "nav-menu__link activePage"
                          : "nav-menu__link"
                      }
                    >
                      Contact Us
                    </NavLink>
                  </li>
                </ul>
                {/* Nav Menu End */}
              </div>
              {/* Menu End  */}
            {/* Header Right start */}
            <div className='header-right flex-align ms-auto ms-lg-0'>
              {/* Phone number commented out in navbar - now active as a floating widget
              <Link
                to='/tel: 9449 818 329'
                className='bg-main-600 text-white hover-bg-main-800 flex-align gap-8 d-lg-flex d-none'
                style={{ padding: '0 18px', height: '48px', alignItems: 'center', justifyContent: 'center' }}
              >
                <div className='d-flex text-32'>
                  <i className='ph ph-phone-call' />
                </div>
                <span style={{ fontSize: '0.85rem', fontWeight: 600, letterSpacing: '0.02em' }}>
                  9449 818 329
                </span>
              </Link>
              */}
              <style>{`
                @media (max-width: 991px) {
                  .mobile-icon-wrapper { gap: 12px !important; }
                  .mobile-icon { font-size: 20px !important; }
                  .mobile-icon-badge {
                    width: 15px !important;
                    height: 15px !important;
                    font-size: 9px !important;
                    top: -4px !important;
                    right: -5px !important;
                    line-height: 1;
                  }
                  .toggle-mobileMenu { font-size: 24px !important; }
                }
              `}</style>
              <div className='me-8 d-lg-none d-block'>
                <div className='flex-align flex-wrap gap-12 mobile-icon-wrapper'>

                  <Link to='/wishlist' className='flex-align gap-4 item-hover'>
                    <span className='text-2xl mobile-icon text-gray-700 d-flex position-relative me-2 mt-6 item-hover__text'>
                      <i className='ph ph-heart' />
                      <span className='w-16 h-16 mobile-icon-badge flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4'>
                        {wishlistItems.length}
                      </span>
                    </span>
                  </Link>
                  <Link to='/cart' className='flex-align gap-4 item-hover'>
                    <span className='text-2xl mobile-icon text-gray-700 d-flex position-relative me-2 mt-6 item-hover__text'>
                      <i className='ph ph-shopping-cart-simple' />
                      <span className='w-16 h-16 mobile-icon-badge flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4'>
                        {cartItems.length}
                      </span>
                    </span>
                  </Link>
                </div>
              </div>
              <button
                onClick={handleMenuToggle}
                type='button'
                className='toggle-mobileMenu d-lg-none ms-2 text-gray-800 text-4xl d-flex'
              >
                <i className='ph ph-list' />
              </button>
            </div>
            {/* Header Right End  */}
          </nav>
        </div>
      </header>
      {/* ==================== Header End Here ==================== */}
    </>
  );
};

export default HeaderOne;
